
import React, { useState } from "react";
import { FormElement, FormLabel, FormInput } from "../StyledElements";
import { Dialog } from "../Dialog";
import swal from "sweetalert2";
import { runAgentWorkflowGraph } from "../../services/agents";
import { runWorkflowGraph } from "../../services/workflows";

export const RunWorkflowDialog = ({ workflow, agent, workflowGraph, title, show, onClose }) => {
  const [input, setInput] = useState("");
  const [context, setContext] = useState("");
  const [output, setOutput] = useState("");


  const runWorkflow = async () => {
    if (agent?.public_id) {
      // Here you would typically call a service to run the workflow
      let runContext;
      try {
        runContext = context ? JSON.parse(context) : {};
      } catch (error) {
        swal.fire({
          title: "Error",
          text: "Context must be in valid JSON format.",
          icon: "error",
          confirmButtonText: "OK"
        });
        return;
      }
      const results = await runAgentWorkflowGraph(agent.public_id, input, runContext);
      console.log("!!! RUN AGENT WORKFLOW RESULTS: ", results);
      if (results.success) {
        setOutput(results.output);
      } else {
        swal.fire({
          title: "Error",
          text: results.message || "Failed to run the agent workflow.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    } else if (workflow?.public_id) {
      // Here you would typically call a service to run the workflow
      const results = await runWorkflowGraph(workflow.public_id, input);
      console.log("!!! RUN AGENT WORKFLOW RESULTS: ", results);
      if (results.success) {
        setOutput(results.output);
      } else {
        swal.fire({
          title: "Error",
          text: results.message || "Failed to run the workflow.",
          icon: "error",
          confirmButtonText: "OK"
        });
      }
    } else {
      swal.fire({
        title: "Error",
        text: "No valid workflow or agent found to run.",
        icon: "error",
        confirmButtonText: "OK"
      });
    }
  }

  console.log("!!! RUN WORKFLOW DIALOG: ", workflow);

  /*
  useEffect(() => {
    const localInputs = {};
    if (workflowGraph) {
      workflowGraph.edges.forEach(e => {
        if (e?.source === "1") {
          localInputs[e.label] = "";
        }
      });
    }
    console.log("!!! LOCAL INPUTS: ", localInputs);
    setInputs(localInputs);

  }, [workflowGraph]);
  */

  return (
    <Dialog
      title="Run Workflow"
      subtitle={title}
      show={show}
      onClose={onClose}
      onOK={runWorkflow}
      okText="Submit"
      closeText="Close"
      style={{ width: "600px" }}
    >
      <FormElement style={{ marginBottom: "10px" }}>
        <FormLabel label="Context" />
        <FormInput
          as="textarea"
          placeholder="Enter context for the workflow here (JSON format)"
          onChange={(e) => {
            setContext(e.target.value);
          }}
          style={{ height: "100px", resize: "vertical" }}
        />
      </FormElement>
      <FormElement style={{ marginBottom: "10px" }}>
        <FormLabel label="Input" />
        <FormInput
          as="textarea"
          placeholder="Enter input for the workflow here"
          onChange={(e) => {
            setInput(e.target.value);
          }}
          style={{ height: "100px" }}
        />
      </FormElement>

      <FormElement style={{ marginBottom: "10px" }}>
        <FormLabel label="Workflow Output" />
        <FormInput
          as="textarea"
          placeholder="Output will be displayed here after running the workflow"
          readOnly
          value={typeof output === "object" ? JSON.stringify(output, null, 2) : output}
          style={{ resize: "vertical", minHeight: "200px" }}
        />
      </FormElement>

    </Dialog>
  );
};

export default RunWorkflowDialog;
